import { Component, Input } from '@angular/core';
import { FooterComponent, FooterComponentData } from '../footer.model';

@Component({
  selector: 'app-geoboxau-footer',
  templateUrl: './geoboxau-footer.component.html',
  styleUrls: ['./geoboxau-footer.component.scss'],
})
export class GeoBoxAUFooterComponent implements FooterComponent {
  @Input() data: FooterComponentData;
}
